import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { ObjectifSpecifique } from 'src/app/shared/models/objectif_specifique';
import { Resultats } from 'src/app/shared/models/resultat';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';

@Component({
  selector: 'app-update-resultats',
  standalone: false,
  templateUrl: './update-resultats.component.html',
  styleUrl: './update-resultats.component.scss'
})

export class UpdateResultatsComponent {


  constructor(
    private modalService: NgbModal,

    private paramService: ParameterService,
    private messageService: MessageService,
    private FecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,



  ) {

  }

  ngOnInit() {
      this.items = this.localStorage.getObjectif();
    this.item = { ...this.items };

    console.log(this.items);

    this.getObjectif();
  }

  close() {

    this.modalService.dismissAll();
  }

  item: Resultats = new Resultats();
  ObjectifItems: any = []
  agenceData: any = [];
  resultatItems: any = [];
  items: any = {};


  editObejectif() {

    // if (!this.item.canSave()) {
    //   this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });

    // } else {

      this.ngxService.start();
      this.item.objectifs_specifiques_id = this.item.objectifs_specifiques_id.id
      this.paramService.editResultat( this.item ,this.items.reference,).subscribe(
        (response: any) => {
          ////console.log("la reponse du webservice",response);

          this.modalService.dismissAll();
          this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
          this.FecthDataService.notifySeriviceCreated();
          this.ngxService.stop();
        },
        (error: any) => {
          const errorMessage = error?.error?.message
            || error?.error?.error
            || error?.message
            || 'Une erreur est survenue';
          //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: errorMessage });
          this.FecthDataService.notifySeriviceCreated();
          this.ngxService.stop();


        }
      )
  //  }

  }

  getObjectif() {


    this.paramService.getObjectif().subscribe(

      (response: any) => {

        this.ObjectifItems = response.data;

         this.item.objectifs_specifiques_id = this.ObjectifItems.find(
          (p: any) => p.id === this.items?.objectif_specifique?.id
        );
        ////console.log("this.programmeData",this.programmeData);
      },
      (error) => {
        ////console.log("une erreur est survenu",error);

      }

    );
  }
  onSelectObjectif(){

    this.item.code = this.item.objectifs_specifiques_id.code + '.'
  }
}
